import { render } from "./SchedulationAgendaDisplay.vue?vue&type=template&id=836525c4&scoped=true&ts=true"
import script from "./SchedulationAgendaDisplay.vue?vue&type=script&lang=ts"
export * from "./SchedulationAgendaDisplay.vue?vue&type=script&lang=ts"

import "./SchedulationAgendaDisplay.vue?vue&type=style&index=0&id=836525c4&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-836525c4"]])

export default __exports__